import React from 'react'
import styled from 'styled-components'

const CheckboxContainer = styled.span`
  display: flex;
  vertical-align: middle;
  position: relative;
`

const CheckMark = styled.span`
  fill: none;
  stroke: ${props => (props.checkedColor ? props.checkedColor : '#00678e')};
  stroke-width: 2px;
`

const IndeterminateMark = styled.span`
  fill: none;
  stroke:${props => (props.checkedColor ? props.checkedColor : '#00678e')};
  stroke-width: 2px;
`

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  width: 14px !important;
  height: 14px !important;
  position: absolute;
  left: 0;
  z-index: ${props => ((props.zIndex) ? (props.zIndex + ' !important') : ('999 !important'))};
  cursor: pointer;
  opacity: 0;
  top: 0;
  bottom: 0; 
  right: 0;
`

const StyledCheckbox = styled.div`
  display: flex;
  width: 14px;
  height: 14px;
  background: ${props => ((props.checked || props.indeterminate) ? '#FFF' : 'transparent')}
  border-radius: 2px;
  border: ${props => ((props.checked || props.indeterminate) ? ('1px solid ' + (props.checkedColor ? props.checkedColor : '#00678e')) : '1px solid #b0bcd0')};

  ${HiddenCheckbox}:focus, ${HiddenCheckbox}:hover + & {
    border-color: ${props => (props.checkedColor ? props.checkedColor : '#00678e')};
  }

  ${HiddenCheckbox}[disabled]:focus, ${HiddenCheckbox}[disabled]:hover + &  {
    border-color: #b0bcd0; 
  }

  ${IndeterminateMark} {
    visibility: ${props => (props.indeterminate ? 'visible' : 'hidden')}
    position: absolute;
    border: 2px solid #ffffff;
    content: ' ';
    background: ${props => (props.checkedColor ? props.checkedColor : '#00678e')};
    width: 12px;
    height: 12px;
  }


  ${CheckMark} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
    transform: rotate(45deg);
    position: absolute;
    border: 2px solid #ffffff;
    border-top: 0;
    border-left: 0;
    content: ' ';
    border-color: ${props => (props.checkedColor ? props.checkedColor : '#00678e')};
    left: 5px;
    top: 1px;
    width: 5px;
    height: 10px;
  }
`

const Checkbox = ({ className, checked, indeterminate, checkedColor, ...props }) => (
  <CheckboxContainer className={className}>
    <HiddenCheckbox checked={checked} indeterminate={indeterminate} checkedColor={checkedColor} {...props} />
    <StyledCheckbox checked={checked} indeterminate={indeterminate} checkedColor={checkedColor}>
      {checked &&
        <CheckMark checkedColor={checkedColor} />
      }
      {indeterminate &&
        <IndeterminateMark checkedColor={checkedColor} />
      }
    </StyledCheckbox>
  </CheckboxContainer>
)


export default Checkbox
